/**
 * Ids reutilizáveis pelo front para identificar teleobjetos por id em vez de comparar por name/shortName.
 * Deve espelhar os enums do main-api que catalogam a tabela `tele_object_data_type`:
 */
export const TELE_OBJECT_DATA_TYPE_ID = {
    DC_VOLTAGE: 2,
    DC_CURRENT: 4,
    ACTIVE_POWER: 5,
    REACTIVE_POWER: 8,
    APPARENT_POWER: 9,
    EXPORTED_ENERGY: 10,
    EFFICIENCY: 11,
    TEMPERATURE: 12,
    FREQUENCY: 14,
    POWER_FACTOR: 15,
    IMPORTED_ENERGY: 17,
    BMS_BATTERY_CHARGE: 31,
    ALARMED: 39,
    TOTAL_GENERATION: 41,
    AVAILABLE_CAPACITY: 46,
    SOC: 47,
    CYCLE_COUNT: 48,
} as const;
